import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { TOP_BAR } from '../mock/mock';

export default function CallButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      try { window.fbq('track', 'Contact'); } catch (e) { /* noop */ }
    }
  };

  return (
    <a
      href={`tel:${TOP_BAR.phone}`}
      onClick={handleClick}
      aria-label="Hívjon most"
      className={`fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group inline-flex items-center gap-3 pl-4 pr-5 md:pl-5 md:pr-6 py-3.5 md:py-4 rounded-full bg-[#2BA8C0] hover:bg-[#239ab1] text-white font-semibold text-[14px] md:text-[15px] shadow-[0_10px_30px_rgba(43,168,192,0.45)] ring-2 ring-white/30 transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    >
      {/* pulsing ring (no pointer events, so it never blocks other clicks) */}
      <span aria-hidden className="absolute inset-0 rounded-full bg-[#2BA8C0]/60 animate-ping opacity-40 pointer-events-none" />
      <span className="relative w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
        <Phone className="w-4 h-4 md:w-[18px] md:h-[18px] text-white fill-white" />
      </span>
      <span className="relative whitespace-nowrap">
        <span className="block text-[10px] uppercase tracking-[0.2em] text-white/80 leading-none mb-1">Hívjon most</span>
        <span className="block leading-none">{TOP_BAR.phone}</span>
      </span>
    </a>
  );
}
